/**
 * Redondeo de importes monetarios
 */
export const redondear2 = value => {
    const n = Number(value);
    if (!Number.isFinite(n)) return n;
    return (Math.sign(n) * Math.round(Math.abs(n) * 100 + 1e-6)) / 100;
};

export const calcularImporteLinea = (cantidad, precioUnitario, porcentajeDescuento) => {
    const factor = Math.max(1 - (Number(porcentajeDescuento) || 0) / 100, 0);
    const precioUnitarioConDto = redondear2((Number(precioUnitario) || 0) * factor);
    return redondear2(precioUnitarioConDto * (Number(cantidad) || 0));
};
